interface EventLike {
  preventDefault(): void;
  stopPropagation(): void;
}

export function disablePropagation<E extends EventLike>(fn: (e: E) => void): (e: E) => void {
  return (e: E) => {
    e.preventDefault();
    e.stopPropagation();
    fn(e);
  };
}
